import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { graphqlClient } from "@/lib/graphql-client";
import { CompanyPlanQuery } from "./query";
export function useCompanyPlanQuery() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["company-plan"],
      queryFn: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}
function _temp2() {
  return graphqlClient.request(CompanyPlanQuery).then(_temp);
}
function _temp(res) {
  return res.company;
}